// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__29epB","header":"MessagesList_header__1Vo1J","chat":"MessagesList_chat__3yunD"};